import React from "react";
import faker from "faker";
import SmartDataTable from "react-smart-data-table";
import { Link } from "react-router-dom";
// Import basic styling
import "react-smart-data-table/dist/react-smart-data-table.css";
const TransactionsTable = [];
const numTransactResults = 1;
for (let i = 0; i < numTransactResults; i++) {
  TransactionsTable.push({
    fullName: faker.name.findName(),
    transactionid: faker.datatype.number(),
    datetime: faker.datatype.number(),
    amount: faker.datatype.number(),
    status: faker.name.findName(),
    transtype: faker.name.findName(),
  });
}
const headers = {
  fullName: {
    text: "Description",
    invisible: false,
    sortable: true,
    filterable: true,
    transform: (value, index, row) => {
      return (
        <>
          <div className="StudentData">
            <p>
              Class Name or Payment Description Will Be Here and can be
              multiline if need be
            </p>
          </div>
        </>
      );
    },
  },
  transactionid: {
    text: "Transaction ID",
    invisible: false,
    sortable: true,
    filterable: true,
    transform: (value, index, row) => {
      return (
        <>
          <p>{value}</p>
        </>
      );
    },
  },
  datetime: {
    text: "Date and Time",
    invisible: false,
    sortable: true,
    filterable: true,
    transform: (value, index, row) => {
      return (
        <>
          <p>{value}</p>
        </>
      );
    },
  },
  amount: {
    text: "amount",
    invisible: false,
    sortable: true,
    filterable: true,
    transform: (value, index, row) => {
      return (
        <>
          <p>{value}</p>
        </>
      );
    },
  },
  status: {
    text: "Payment Status",
    invisible: false,
    sortable: true,
    filterable: true,
    transform: (value, index, row) => {
      return (
        <>
          <p>{value}</p>
        </>
      );
    },
  },
  transtype: {
    text: "Transaction type",
    invisible: false,
    sortable: true,
    filterable: true,
    transform: (value, index, row) => {
      return (
        <>
          <p>{value}</p>
        </>
      );
    },
  },
  action: {
    text: "Action",
    invisible: false,
    sortable: false,
    filterable: true,
    transform: (value, index, row) => {
      return (
        <>
          <Link to="#" className="edit-userbtn">
            <i className="far fa-times-circle"></i>
          </Link>
        </>
      );
    },
  },
};
export default function Transactions() {
  return (
    <SmartDataTable
      data={TransactionsTable}
      responsive={true}
      name="test-table"
      className="ui compact selectable table eventsDataTable"
      sortable
      headers={headers}
    />
  );
}
